require('@tarekraafat/autocomplete.js/dist/css/autoComplete.02.css');
window.autoComplete = require("@tarekraafat/autocomplete.js");

function __init({root_id, debounce, limit, display_thumbnail, placeholder, cache, value, filters, page_results_enabled}) {

    const getResultItemContent = (type, {text, url, displayThumbnail, metadata}) => {
        const __default = {
            url,
            text,
            image: displayThumbnail ? metadata.image : null,
            description: null,
            external: metadata.external ?? false,
        };

        switch (type) {
            case 'franchise':
                return {
                    ...__default,
                    description: `Franchise - ${metadata.industry}, ${metadata.category}`,
                };
            case 'blog':
                return {
                    ...__default,
                    description: metadata.excerpt ?? '',
                };
            case 'industry':
                return {
                    ...__default,
                    description: 'Browse all franchises from this industry',
                };
            case 'fdd':
                return {
                    ...__default,
                    image: displayThumbnail ? 'https://cdn.vettedbiz.com/wp-content/uploads/2020/12/16022540/franchise-disclosure-document-vettedbiz-cover.jpg' : null,
                    description: `${metadata.franchise_name} franchise ${metadata.year} FDD (Franchise Disclosure Document) PDF download. The biggest FDD database. Buy now.`,
                };
            case 'youtube':
                return {
                    ...__default,
                    description: 'Youtube video',
                };
            default:
                return __default;
        }
    }

    const render = (element, type, data) => {
        const {url, image, text, description, external} = getResultItemContent(type, data);

        const imageElement = image ? `<img src="${image}" alt="${text}" />` : '';
        const target = external ? '_blank' : '_self';

        element.innerHTML = `
                    <a class="gs-result-item" href="${url}" target="${target}">
                        <div class="gs-result-image-wrapper">
                            ${imageElement}
                        </div>
                        <div class="gs-result-info">
                            <div class="gs-result-title">${text}</div>
                            <div class="gs-result-description">${description ?? ''}</div>
                        </div>
                    </a>
            `;
    };

    const localCache = {
        _cache: {},
        get: function (key) {
            return this._cache[key] || null;
        },
        set: function (key, value) {
            if (cache) {
                this._cache[key] = value;
            }
        }
    };

    const selector = '#' + root_id + ' input';

    const addViewAllResultsItem = (query, results) => {
        if (page_results_enabled) {
            results.push({
                text: `See all results for "${query}"`,
                type: 'page',
                url: `/search/?q=${query}`,
                metadata: {}
            });
        }

        return results
    }

    const search = async ({query}) => {
        const nonce = await vf.services.getOrFetchNonce();

        const response = await fetch('/wp-json/visa-franchise/v1/global-search', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': nonce
            },
            body: JSON.stringify({
                term: query,
                limit,
                filters: {'type': (filters.indexOf(',') > -1) ? filters.split(',') : [filters]},
                source_page_url: window.location.href,
                src: root_id
            }),
        });

        if (response.status === 403) {
            return null;
        }

        return await response.json();
    };

    // See https://tarekraafat.github.io/autoComplete.js/#/configuration
    const config = {
        selector,
        placeHolder: placeholder,
        debounce,
        data: {
            src: async (query) => {
                if (!query.replace(/ /g, "").length) {
                    return [];
                }

                if (localCache.get(query)) {
                    return addViewAllResultsItem(
                        query,
                        localCache.get(query)
                    );
                }

                if (query.length >= 3) {
                    let data = await search({query});

                    if (!data) {
                        vf.services.clearNonce();
                        data = await search({query});
                    }

                    localCache.set(query, data.data);

                    return addViewAllResultsItem(query, data.data);
                }
                return [];
            },
            keys: ['text']
        },
        // Do not search for empty strings
        trigger: (query) => {
            return query.replace(/ /g, '').length;
        },
        searchEngine: (query, record) => {
            return record;
        },
        resultItem: {
            highlight: false,
            element: (item, data) => {
                render(item, data.value.type, {
                    ...data.value,
                    displayThumbnail: display_thumbnail,
                });
            },
        },
        resultsList: {
            maxResults: page_results_enabled ? limit + 1 : limit,
        },
        submit: true
    };

    const input = document.querySelector(selector);

    input
        // This is needed for "enter press" navigation that does not trigger the link click
        .addEventListener('selection', function (event) {
            if (!event || !event.detail || !event.detail.selection || !event.detail.selection.value) {
                return;
            }

            const {url, metadata} = event.detail.selection.value;

            if (!url) {
                return;
            }

            if (metadata && metadata.external) {
                window.open(url, '_blank');
            } else {
                window.location = url;
            }

        });

    // Set the value if it is provided (initial render)
    if (value) {
        input.value = value;
    }

    if (page_results_enabled) {
        input.addEventListener('keyup', (event) => {
            if (event.key === 'Enter') {
                const query = event.target.value;

                if (!query.replace(/ /g, "").length) {
                    return;
                }

                window.location = `/search/?q=${query}`;
            }
        });
    }

    // No need to expose this
    new autoComplete(config);
};

if (!window.vf) {
    window.vf = {};
}

window.vf.initGlobalSearch = __init;